// extracted by mini-css-extract-plugin
export default {"inputContent":"MessageInput_inputContent__nyMT0","disabledSuffix":"MessageInput_disabledSuffix__NLopl"};